// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const estadosIncidenciaFullfilledReducer = makeSetReducer(['estados_incidencia/fullfilled']);
